export enum ProductKind {
  STANDARD = "standard",
  VARIATION = "variation",
  COMPOSITE = "composite",
}

export enum ProductStockAvailability {
  STOCKED = "stocked",
  IN_STORE_ONLY = "in_store_only",
  LIMITED = "limited",
  ONLINE_ONLY = "online_only",
  OUT_OF_STOCK = "out_of_stock",
  ARCHIVED = "archived",
  PREORDER = "preorder",
  PRESALE = "presale",
  SOLDOUT = "soldout",
  DISCONTINUED = "discontinued",
}

export enum InventoryPolicy {
  DENY = "deny",
  CONTINUE = "continue",
}

export enum ProductOptionValueType {
  TEXT = "text",
  COLOR = "color",
  IMAGE = "image",
}
